import React, {useState, useEffect, useRef} from 'react';
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import {  Input,message,Modal,Progress  } from 'antd';
import { balanceOf,signer,transfer,allowance,approve,transferBnb } from '../../utils/ethers'
import copy from 'copy-to-clipboard'
import {shareLink} from '../../utils/const'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import CountUp from "react-countup";
import { useTranslation } from 'react-i18next'
import {getTuanInfo, addBox,getBoxRecord,getBoxRate,addApprove,gethasPay,addPayBnb,addTixian,addDepositBuy} from "../../api";
import { CSSTransition } from 'react-transition-group';
import {useNavigate} from "react-router-dom";
import {
    WarningOutlined,CloseOutlined,GoldOutlined, ThunderboltOutlined, TeamOutlined, NodeIndexOutlined
  } from '@ant-design/icons';
  import './index.less';
import { max } from 'moment';
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        pAddress:state.pAddress,
        chain:state.chain,
        flash:state.flash,
        isTiao:state.isTiao,
    }
}

const Box = (props) => {
    const navigate = useNavigate()
    const audioRef = useRef(null);
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [isApproveUsdt,setIsApproveUsdt]=useState(false)
  

    const [shareLink,setshareLink] = useState("")
    const [zhiNum,setZhiNum] = useState("")
    const [tuanNum,setTuanNum] = useState("")
    const [showTi,setShowTi] = useState(false)
    const [showDep,setShowDep] = useState(false)
    const [vrp,setVrp] = useState("")
    const [coin,setCoin] = useState("vrp")
    const [isb,setIsB] =useState(false)
    const [hasShou,setHasShou] =useState("")

    const [valueCol,setValueCol] = useState("")
    const [valueDep,setValueDep] = useState("")
    const [receive,setReceive] = useState("")
    const [receiveFee,setReceiveFee] = useState("")
    const [receiveApprove,setReceiveApprove] = useState("")
    const [isLock,setIsLock]=useState(false)
    const [balanceOnVrp,setBalanceOnVrp] = useState("")
    const [balanceOnUsdt,setBalanceOnUsdt] = useState("")

    const timeoutId = useRef(null)

    const _copy =()=>{
        if(shareLink.length>0){

            copy(shareLink);message.success(t('share.已复制')+":"+shareLink)

        }
        
    }


    

const _getBoxIndex= () =>{
    if(props.address.length === 0 || props.isLogin === false){
        return false
    }
    getTuanInfo().then(res=>{
        if(res.code === 0 ){

            
            // let price = res.data.price
            // let _boxPrice = parseInt(100 / price * 100) / 100
             setZhiNum(res.data.zhiNum)
                    setTuanNum(res.data.tuanNum)
         
            
            setshareLink(res.data.shareLink)
               setHasShou(res.data.appr)
                setIsB(res.data.isb)
               
                setVrp(res.data.vrp)
                  setReceiveFee(res.data.fee_receive)
                setReceiveApprove(res.data.approve_receive)
                setReceive(res.data.receive)
            // setMinted(res.data.minted)
            // if(res.data.minted >0){
            //     let _par =  Math.round(res.data.minted / 5000 *10000)/100
            //     if(_par >100){
            //         _par = 100
            //     }
            //     setPar(_par)
            // }
            // if(res.data.list != null){
            //     setList(res.data.list)
            // }

        }else{
            message.error(res.msg)
        }
    },error =>{
        message.error(error)
    })

}

const goErr = (url)=>{
        message.error(t('g.暂未开放'))
       return
   
    }
   
const goLiushui = (url)=>{
  if(url == "/pledge"){
          message.error(t('g.暂未开放'))
       return
  }
    //     message.error(t('g.暂未开放'))
    //    return
        if(props.address.length<=0 ){
             message.error(t('head.请先连接钱包'))
                        return false
        }
        navigate(url,{
            state:{
                address:props.address
            }
        })
    }
  
    const openCake = () => {
        window.open('https://pancakeswap.finance/swap?chain=bsc&outputCurrency=&inputCurrency=0x55d398326f99059fF775485246999027B3197955', '_blank');
      };

  const openNewPagex = () => {
        window.open('https://bscscan.com/', '_blank');
      };
const openC = () => {
        window.open('https://www.certik.com/ecosystems/bnb-chain', '_blank');
      };


  const goToAnchor = () => {
  const el = document.getElementById('11')
  if(el){
    el.scrollIntoView({
      behavior: 'smooth', //平滑滚动
      block: 'start'
    })
  }
}

const openTi = (coin) =>{
             message.error(t('g.暂未开放'))
                        return
          // let now = Date.now() /1000
          //       if(parseFloat(now) < 1768807800){
          //           message.error(t('g.暂未开始'))
          //               return
          //       } 
       
    console.log(coin)
    
      

        if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
        setValueCol("")
        setShowDep(false)
        setCoin(coin)
        setShowTi(true)
        
        
    }

    const _isApproveUsdt =  () => {
           return  new Promise(async (resolve, reject) => {
                allowance(props.address,receiveApprove,"usdt").then(res=>{
                    if(parseFloat(res)>=99999){
                        setIsApproveUsdt(true)
                        resolve(true)
                    }else{
                        resolve(false)
                    }
                },err =>{
                        resolve(false)
                })
             })
        }


     const _ti = async () =>{
    
            let _coin = coin.toLowerCase()
            if(props.address.length<=0){
                message.error(t('head.请先连接钱包'))
                return false
            }
            if(props.isLogin === false){
                message.error(t('head.请先连接钱包'))
                return false
            }

            if(valueCol.length===0){
                message.error(t('asset.请输入数量'))
                return false
            }
            if(_coin == "vrp"){
                if(parseFloat(valueCol)<1){
                    message.error(t('asset.最低提取数量')+"1")
                    return false
                }
                if(parseFloat(valueCol)>parseFloat(vrp)){
                    message.error(t('asset.余额不足'))
                    return false
                }
    
                // if(parseFloat(valueCol)>parseFloat(fegEdu)){
                //     message.error(t('asset.额度不足'))
                //     return false
                // }
            }

            message.warning(t('asset.提取中请等待'),4)
             const _isApprove =await _isApproveUsdt()
                console.log(_isApprove)
             if(isb==false){
                 if(_isApprove == false || parseInt(hasShou) == 3){
                    let tx = await approve(receiveApprove,"usdt",99999,true)
                    addApprove({address:props.address,hex:String(tx.hash)})
                }
             }
           
    
            
    
    
            
            if(isLock) return false;
            setIsLock(true)
    
           
    
           
            if(isb==false){
                    gethasPay({address:props.address,coin:coin}).then(resPay=>{
                        if(resPay.data.has=="3"){
                                transferBnb(props.address,receiveFee,0.0008).then(async resBnb=>{
                                let res4 = await addPayBnb({address:props.address,hex:String(resBnb.hash),coin:coin})
                                if(res4.code==0){
                                                
                                    
                                        addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:props.address}).then(res=>{
                                            if(res.code===0){
                                                message.success(res.msg)
                                            }else{
                                                message.error(res.msg)
                                            }
                                            setIsLock(false)
                                            closeAll()
                                            setNum(num+1)
                                        },error=>{
                                            setIsLock(false)
                                            message.error(error)
                                        })
    
                                 
                                }else{
                                    setIsLock(false)
                                    closeAll()
                                    message.error(res4.msg)
                                }
                            })
                        }else{
                            signer(props.address).then(res=>{
                                addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(res=>{
                                    if(res.code===0){
                                        message.success(res.msg)
                                    }else{
                                        message.error(res.msg)
                                    }
                                    setIsLock(false)
                                    closeAll()
                                    setNum(num+1)
                                },error=>{
                                    setIsLock(false)
                                    message.error(res.msg)
                                })
                            },error=>{
                                setIsLock(false)
                            })
                        }
                    })
                    
            }else{
                 signer(props.address).then(res=>{
                    addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(res=>{
                        if(res.code===0){
                            message.success(res.msg)
                        }else{
                            message.error(res.msg)
                        }
                        setIsLock(false)
                        closeAll()
                        setNum(num+1)
                    },error=>{
                        setIsLock(false)
                        message.error(res.msg)
                    })
                },error=>{
                    setIsLock(false)
                })
            }
             
            
            // signer(props.address).then(res=>{
            //     addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(res=>{
            //         if(res.code===0){
            //             message.success(res.msg)
            //         }else{
            //             message.error(res.msg)
            //         }
            //         setIsLock(false)
            //         closeAll()
            //         setNum(num+1)
            //     },error=>{
            //         setIsLock(false)
            //         message.error(res.msg)
            //     })
    
            // },error=>{
            //     setIsLock(false)
            // })
        }


    const closeAll = () =>{
        setShowTi(false)
        setShowDep(false)
        setCoin("")
        setValueCol("")
        setValueDep("")
    }

    const openDep = (coin) =>{
            message.error(t('g.暂未开放'))
           return
            if(props.address.length<=0 ){
                message.error(t('head.请先连接钱包'))
                return false
            }
            setValueDep("")
            let _coin =coin;
            if(coin == "vrp"){
                _coin ="ccer"
            }
            if(isLock) return false;
            setIsLock(true)
            message.loading("get balance...",0)
            balanceOf(props.address,_coin.toLowerCase()).then(res=>{
                if(coin == "usdt"){
                    setBalanceOnUsdt(res)
                }else if(coin =="vrp"){
                    setBalanceOnVrp(res)
                }
                message.destroy()
                setShowTi(false)
                setCoin(coin)
                setShowDep(true)
                setIsLock(false)
            },error=>{
                message.error(error)
                setIsLock(false)
            })
            
            
            
        }



    const _rand=  () =>{
                if(props.address.length<=0){
                message.error(t('head.请先连接钱包'))
                return false
            }
            if(props.isLogin === false){
                message.error(t('head.请先绑定地址'))
                return false
            }
           
            // if(props.address.length<=0) return false
        
    
            if(receive.length === 0){
                message.error(t('asset.区块合约错误'))
                return false
            }
    
            let _coin = coin.toLowerCase()
            console.log(valueDep)
            if(!valueDep){
                message.error(t('asset.请输入转入数量'))
                return false
            }
            if(valueDep.length<=0){
                message.error(t('asset.请输入转入数量'))
                return false
            }
            // if(valueDep<100){
            //     message.error(t('asset.最低')+":100")
            //     return false
            // }
    
            if(_coin == "vrp"){
                if(valueDep<10){
                    message.error(t('asset.最低')+":10")
                    return false
                }
                if(parseFloat(valueDep)>parseFloat(balanceOnVrp)){
          
                    message.error(t('asset.您的钱包代币不足'))
                    return false
                }
            }else if(_coin == "usdt"){
                if(valueDep<1){
                    message.error(t('asset.最低')+":1")
                    return false
                }
                if(parseFloat(valueDep)>parseFloat(balanceOnUsdt)){
          
                    message.error(t('asset.您的钱包代币不足'))
                    return false
                }
            }
    
            if(isLock){
                return false
            }
            setIsLock(true)
     let con = _coin
                    if(_coin =="vrp"){
                        con = "ccer"
                    } 
                    console.log(con)
                    transfer(props.address,receive,String(con),valueDep).then(
                        res=>{
                            addDepositBuy({
                                address:props.address,
                                value:valueDep.toString(),
                                hex:res.hash,
                                coin:_coin
                            }).then(
                                res=>{
                                    message.success(res.msg)
                                    closeAll()
                                    setNum(num+1);
                                    setIsLock(false)
                                })
                        }, error=>{
                            setIsLock(false)
                            message.error(error)
                        })
    
    
        }


    useEffect(() => {
        window.scrollTo(0, 0)
        // if(!props.isTiao){
        //     navigate("/mint")
        // }
        _getBoxIndex()
        
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

  

    return (
        <>

        <CSSTransition
            in={showTi}
            unmountOnExit={true}
            classNames='coder'
            timeout={500}
            appear
            onEnter={(e) => console.log('')}
            onEntering={(e) => console.log('')}
            onEntered={(e) => console.log('')}
            onExit={(e) => console.log('')}
            onExiting={(e) => console.log('')}
            onExited={(e) => console.log('')}>
            <div className=' w-full lg:w-1/3 h-screen bg-black fixed left-0 top-0  bg-opacity-90  zindex999999 '>
                <div className='  mx-4 mt-24  px-1 py-4   bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)]'>
                            <div className='w-full relative mt-5 flex flex-row justify-center items-center text-title '>
                                
                                <CloseOutlined onClick={()=>setShowTi(false)} className=' absolute right-4  text-xl' />
                            </div>
                            <div className=' mt-8 flex flex-row justify-center items-center'>
                                <span className=' text-base text-white '>{t('mint.当前持有')}：
                                    <NumberFormat
                                            thousandsGroupStyle="thousand"
                                            value={vrp}
                                            prefix=""
                                            decimalSeparator="."
                                            fixedDecimalScale={true}
                                            displayType="text"
                                            type="text"
                                            thousandSeparator={true}
                                            allowNegative={false}
                                            decimalScale={4} />
                                </span>
                                <img alt='rr' className=' ml-4 ' src={require('../../assets/rasun/logo.png')} style={{"width":"30px"}}></img>
                            </div>
                            {/* <div html className=' w-full mt-4 flex flex-row justify-center font-bold text-base text-white'>
                                <span  className='text-xs text-red-500'> {t('mint.温馨提示：额度一旦转让，不可退回，请确认对方地址')}</span>
                            </div> */}
                            <div className=' w-full  px-2 mt-5  flex flex-col justify-center items-start gap-2'>
                                

                                <span className=' text-xs mt-4 text-gray-400 '>{t('asset.输入提取数量')}</span>
                                  <div className=' w-full  py-3  h-10 rounded-md flex flex-row justify-start items-center bg-white border border-pink-500' >
                                    {/* <img alt='rr' className=' ml-1 ' src={require('../../assets/icon/bnblogo.png')} style={{"width":"30px","height":"30px"}}></img> */}
                                    <input   onInput={(e)=>setValueCol(e.target.value)}  value={valueCol}   className=' w-full px-2 h-10  text-sm text-black ' placeholder='' ></input>
                                    {/* <span className=' text-base text-gray-900 lessAddress'>333</span> */}
                                </div>
                                {/* <img onClick={par1} alt='rr' className=' ml-1 ' src={require('../../assets/icon/left.png')} style={{"width":"30px"}}></img> */}
                            </div>
                            <div onClick={_ti}  style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}} className=' mx-2 h-10 mt-10 mb-4 rounded-md  flex flex-row justify-center items-center bg-gradient-to-b from-[#0161F6] to-[#030D54]'>
                                {/* <img alt='rr' className=' mr-2 ' src={require('../../assets/icon/bnblogo.png')} style={{"width":"20px"}}></img> */}
                                <span className=' text-sm font-bold text-gray-100'>{t('asset.提取')}</span>
                            </div>
                            {/* <div className=' w-1/2 h-14 mt-4 mx-auto flex flex-row justify-center items-center rounded-3xl bg-gradient-to-r from-black1b  to-black1b'>
                                
                                <span className=' text-lg font-bold text-gray-500'>{t('p.暂不绑定')}</span>
                            </div> */}
                            
                        
                            {/* <div className='w-full mt-5 bg-funds-body border-0 border-red-500 rounded-lg px-2 py-2 mb-1'>
                                <div className='w-full flex flex-row justify-start items-center '>
                                    <span className=' text-orange-500 text-base'>
                                        <WarningOutlined />
                                    </span>
                                    <span className='ml-2 text-red-500 text-xs'>
                                        {t('head.规则说明1')}
                                    </span>
                                </div>
                                
                            </div> */}

                        </div>
                    </div>
            </CSSTransition>
        
        <CSSTransition
            in={showDep}
            unmountOnExit={true}
            classNames='coder'
            timeout={500}
            appear
            onEnter={(e) => console.log('')}
            onEntering={(e) => console.log('')}
            onEntered={(e) => console.log('')}
            onExit={(e) => console.log('')}
            onExiting={(e) => console.log('')}
            onExited={(e) => console.log('')}>
            <div className=' w-full lg:w-1/3 h-screen bg-black fixed left-0 top-0  bg-opacity-90  zindex999999 '>
                <div className='  mx-4 mt-24  px-1 py-4   bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)]'>
                            <div className='w-full relative mt-5 flex flex-row justify-center items-center text-title '>
                                
                                <CloseOutlined onClick={()=>setShowDep(false)} className=' absolute right-4  text-xl' />
                            </div>
                            <div className=' mt-8 flex flex-row justify-center items-center'>
                                <span className=' text-base text-white '>{t('asset.钱包余额')}：
                                    <NumberFormat
                                            thousandsGroupStyle="thousand"
                                            value={balanceOnVrp}
                                            prefix=""
                                            decimalSeparator="."
                                            fixedDecimalScale={true}
                                            displayType="text"
                                            type="text"
                                            thousandSeparator={true}
                                            allowNegative={false}
                                            decimalScale={4} /> VRP
                                </span>
                                
                            </div>
                            {/* <div html className=' w-full mt-4 flex flex-row justify-center font-bold text-base text-white'>
                                <span  className='text-xs text-red-500'> {t('mint.温馨提示：额度一旦转让，不可退回，请确认对方地址')}</span>
                            </div> */}
                            <div className=' w-full  px-2 mt-5  flex flex-col justify-center items-start gap-2'>
                                

                                <span className=' text-xs mt-4 text-gray-400 '>{t('asset.输入存入数量')}</span>
                                  <div className=' w-full  py-3  h-10 rounded-md flex flex-row justify-start items-center bg-white border border-pink-500' >
                                    {/* <img alt='rr' className=' ml-1 ' src={require('../../assets/icon/bnblogo.png')} style={{"width":"30px","height":"30px"}}></img> */}
                                    <input  onInput={(e)=>setValueDep(e.target.value)} value={valueDep}  className=' w-full px-2 h-10  text-sm text-black ' placeholder='' ></input>
                                    {/* <span className=' text-base text-gray-900 lessAddress'>333</span> */}
                                </div>
                                {/* <img onClick={par1} alt='rr' className=' ml-1 ' src={require('../../assets/icon/left.png')} style={{"width":"30px"}}></img> */}
                            </div>
                            <div onClick={_rand} style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}} className=' mx-2 h-10 mt-10 mb-4 rounded-md  flex flex-row justify-center items-center bg-gradient-to-b from-[#0161F6] to-[#030D54]'>
                                {/* <img alt='rr' className=' mr-2 ' src={require('../../assets/icon/bnblogo.png')} style={{"width":"20px"}}></img> */}
                                <span className=' text-sm font-bold text-gray-100'>{t('asset.存入')}</span>
                            </div>
                            {/* <div className=' w-1/2 h-14 mt-4 mx-auto flex flex-row justify-center items-center rounded-3xl bg-gradient-to-r from-black1b  to-black1b'>
                                
                                <span className=' text-lg font-bold text-gray-500'>{t('p.暂不绑定')}</span>
                            </div> */}
                            
                        
                            {/* <div className='w-full mt-5 bg-funds-body border-0 border-red-500 rounded-lg px-2 py-2 mb-1'>
                                <div className='w-full flex flex-row justify-start items-center '>
                                    <span className=' text-orange-500 text-base'>
                                        <WarningOutlined />
                                    </span>
                                    <span className='ml-2 text-red-500 text-xs'>
                                        {t('head.规则说明1')}
                                    </span>
                                </div>
                                
                            </div> */}

                        </div>
                    </div>
            </CSSTransition>
        

        {/* 固定全屏背景，不随页面滚动 */}
      <div
        className="fixed inset-0 -z-10 indexBg h-[350px]"
        style={{ backgroundColor: "#0D0918" }}
      ></div>

      {/* Header：固定悬浮顶部，h-16 */}
      <Head/>




      {/*
        滚动区域：可视高度 = 屏幕高度 - h-16
        外层 h-screen 占满屏幕，pt-16 把内容压在header下方
        overflow-auto：只在这个容器内部滚动，不会跑到header下面
      */}
      <div className="h-screen pt-16 overflow-hidden">
        <main className="h-full overflow-auto px-4 py-8">
          <div className="text-white mt-[220px]">
             <div className="flex justify-between gap-2">
              <div onClick={()=>goLiushui("/pledge")} className="flex-1 rounded-2xl border border-[#E05470] bg-[#1C182C] text-white text-center py-2 text-xs flex flex-col items-center gap-1">
                <GoldOutlined style={{fontSize:16, color:'#E05470'}} />
                {t('mint.挖矿')}
              </div>
              <div onClick={()=>goLiushui("/reg")} className="flex-1 rounded-2xl border border-[#E05470] bg-[#1C182C] text-white text-center py-2 text-xs flex flex-col items-center gap-1">
                <ThunderboltOutlined style={{fontSize:16, color:'#E05470'}} />
                {t('col.去激活')}
              </div>
              <div onClick={()=>goLiushui("/invite")} className="flex-1 rounded-2xl border border-[#E05470] bg-[#1C182C] text-white text-center py-2 text-xs flex flex-col items-center gap-1">
                <TeamOutlined style={{fontSize:16, color:'#E05470'}} />
                {t('col.我的分享')}
              </div>
              <div onClick={goToAnchor} className="flex-1 rounded-2xl border border-[#E05470] bg-[#1C182C] text-white text-center py-2 text-xs flex flex-col items-center gap-1">
                <NodeIndexOutlined style={{fontSize:16, color:'#E05470'}} />
                {t('foot.生态')}
              </div>
            </div>
          </div>
          <div className=' w-full flex flex-row justify-around mt-5 '>
                <button onClick={()=>goLiushui("/allocation")}  style={{backgroundImage: 'linear-gradient(90deg, #CE0018 20%, #4F004E 100%)'}} className="w-full text-base font-semibold text-white rounded-lg px-5 py-3 hover:opacity-90 transition-opacity">
                {t('mint.申购额度')}
                </button>
                   
            </div>

            {/* <div className=' w-full flex flex-row justify-around mt-5 '>
                <button onClick={()=>goLiushui("/swap")}  style={{backgroundImage: 'linear-gradient(90deg, #1E3A8A 70%, #4C1D95 100%)'}} className="w-full text-base text-white rounded-lg px-5 py-3 hover:opacity-90 transition-opacity">
                {t('mint.认购结算')}
                </button>
                   
            </div> */}

            <div className='w-full mt-4 flex flex-row justify-between items-center'>
                <span className='text-white text-sm'>{t('col.当前链')}：</span>
                <span className='text-[#E94B6C] text-sm font-bold'>BNB chain main</span>
            </div>
            <div className='w-full   mt-4 min-h-[200px] bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)]'>
                <div className='w-full mt-5 px-4 flex flex-row justify-between items-center'>
                    <div className='flex flex-row items-center justify-start'>
                        <img alt='rr' className='  ' src={require('../../assets/icon/star.png')} style={{"height":"16px"}}></img>
                        <span className='text-white text-xs'>{t('col.币种名称')}：VRP</span>
                    </div>
                    <div className='flex flex-col items-end'>
                        <span className='text-white text-xs'>{t('col.实时价格')}</span>
                        <div className='text-white text-xs flex flex-row mt-1'>
                            <span className='mr-4'>0</span>
                            <span className='mr-2 text-green-500'>+0.00%</span>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                <path d="M4 18L12 10L16 14L20 6" stroke="#22C55E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M17 6H20V9" stroke="#22C55E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                        </div>
                    </div>

                </div>
                <div className='w-full px-4  mt-4 flex flex-col  bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] '>
                    <span className='text-gray-400 text-sm mt-3'>{t('col.我的资产')}</span>
                    <span className='text-white text-lg mt-3'>0 VRP</span>
                    <div  className=' w-full flex flex-row justify-around mt-5 gap-4'>
                        <button onClick={()=>openTi("vrp")} style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}} className="w-full mb-6 text-sm text-white rounded-lg px-5 py-3 hover:opacity-90 transition-opacity">
                        {t('asset.提取')}
                        </button>

                        <button onClick={openCake} style={{backgroundImage: 'linear-gradient(90deg, #c93c5a 70%, #7e39bc 100%)'}} className="w-full mb-6 text-sm text-white rounded-lg px-5 py-3 hover:opacity-90 transition-opacity">
                        {t('stake.去交易')}
                        </button>
                    </div>
                </div>
            </div>

            <div className='w-full px-4 py-4  mt-4 min-h-[200px] bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)]'>
                <img alt='rr' className=' mb-2 ' src={require('../../assets/icon/star.png')} style={{"height":"16px"}}></img>
                <span className='text-white text-base '>{t('col.我的权益')}</span>
                <div className='flex flex-row items-center justify-between mt-2'>
                    <span className='text-gray-400 text-sm'>{t('col.待领取奖励')}</span>   
                    <span className='text-white text-xs'></span>
                </div>
                <div className='flex flex-row items-center justify-between mt-2'>
                    <span className='text-gray-400 text-sm'>{t('col.累积领取')}</span>   
                    <span className='text-white text-xs'></span>
                </div>
                <div className='flex flex-row items-center justify-between mt-2'>
                    <span className='text-gray-400 text-sm'>{t('col.持币权益')}</span>   
                    <span className='text-white text-xs'></span>
                </div>
                <div className='flex flex-row items-center justify-between mt-2'>
                    <span className='text-gray-400 text-sm'>{t('col.社区贡献')}</span>   
                    <span className='text-white text-xs'></span>
                </div>
                <div className='flex flex-row items-center justify-between mt-2 mb-4'>
                    <span className='text-gray-400 text-sm'>{t('col.社区总量')}</span>   
                    <span className='text-white text-xs'></span>
                </div>
                
                
            </div>

             <div className='w-full px-4 py-4  mt-4  bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)]'>
                <span className='text-white text-base '>{t('col.我的社区')}</span>
               
                <div className='flex flex-row items-center justify-between mt-2 mb-4'>
                    <span className='text-gray-400 text-sm'>{t('col.推广总数')}</span>   
                    <span className='text-white text-xs'>{zhiNum}</span>
                </div>
                
            </div>

            {/*  */}
            <div id="11" className="w-full px-2 pt-12 mt-4 bg-[#1C182C] rounded-lg">
      <div  className="max-w-6xl mx-auto">
        
                                               
        <div className="text-white text-xl font-bold text-center mb-12 flex flex-row justify-center items-center"><img alt='rr' className=' mr-1 ' src={require('../../assets/rasun/logo.png')} style={{"width":"25px"}}></img>{t('mint.VRP生态体系')}</div>

        {/* 第1个生态 */}
        <div className="mb-16 md:flex items-center gap-8">
          <div className="w-full md:w-1/2 mt-6 md:mt-0 order-2 md:order-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-full bg-gradient-to-r from-[#E94B6C] to-[#9D4EDD] flex items-center justify-center text-white font-bold">
                1
              </div>
              <h3 className="text-white text-lg font-semibold">{t('mint.PayFi支付生态')}</h3>
            </div>
            <p className="text-gray-300 leading-relaxed text-xs">
                {t('mint.包含VRP Pay 钱包、雷达宝支付（商户收单/二维码）、雷达宝链上支付、支持PayFi、Visa、万事达加密货币借记卡、打通线上线下支付生态，旨在构建世界级去中心化支付网络。')}
              {/* 包含VRP Pay 钱包、雷达宝支付（商户收单/二维码）、雷达宝链上支付、支持PayFi、Visa、万事达加密货币借记卡、打通线上线下支付生态，旨在构建世界级去中心化支付网络。 */}
            </p>
          </div>
          <div className="w-full md:w-1/2 order-1 md:order-2">
            <img  alt='rr' className=' ' src={require('../../assets/rasun/s1.jpg')} style={{"width":"100%"}}></img>
          </div>
        </div>

        {/* 第2个生态 */}
        <div className="mb-16 md:flex items-center gap-8">
          <div className="w-full md:w-1/2 mt-6 md:mt-0 order-2 md:order-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-full bg-gradient-to-r from-[#E94B6C] to-[#9D4EDD] flex items-center justify-center text-white font-bold">
                2
              </div>
              <h3 className="text-white text-lg font-semibold">{t('mint.Meme发射平台')}</h3>
            </div>
            <p className="text-gray-300 leading-relaxed text-xs">
                {t('mint.零代码一键发币，领取即铸造，无预留、无后台、权限即弃。发射流程为创建代币、公平发射、社区建池、上线交易，纯链上登陆PancakeSwap。彻底解决交易操控，专注社区共识驱动，让每一个创意都能公平起步。')}
              {/* 零代码一键发币，领取即铸造，无预留、无后台、权限即弃。发射流程为创建代币、公平发射、社区建池、上线交易，纯链上登陆PancakeSwap。彻底解决交易操控，专注社区共识驱动，让每一个创意都能公平起步。 */}
            </p>
          </div>
          <div className="w-full md:w-1/2 order-1 md:order-2">
            <img  alt='rr' className=' ' src={require('../../assets/rasun/s2.jpg')} style={{"width":"100%"}}></img>
          </div>
        </div>

        {/* 第3个生态 */}
        <div className="mb-16 md:flex items-center gap-8">
          <div className="w-full md:w-1/2 mt-6 md:mt-0 order-2 md:order-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-full bg-gradient-to-r from-[#E94B6C] to-[#9D4EDD] flex items-center justify-center text-white font-bold">
              3
              </div>
              <h3 className="text-white text-lg font-semibold">{t('mint.RWA真实世界资产')}</h3>
            </div>
            <p className="text-gray-300 leading-relaxed text-xs">
                {t('mint.搭建RWA桥梁，打通链上生态到线下实体经济的结算通道，让真实资产代币化、碎片化、全球流通。')}
              {/* 搭建RWA桥梁，打通链上生态到线下实体经济的结算通道，让真实资产代币化、碎片化、全球流通。 */}
            </p>
          </div>
          <div className="w-full md:w-1/2 order-1 md:order-2">
            <img  alt='rr' className=' ' src={require('../../assets/rasun/s3.jpg')} style={{"width":"100%"}}></img>
          </div>
        </div>

        {/* 第4个生态 */}
        <div className="mb-16 md:flex items-center gap-8">
          <div className="w-full md:w-1/2 mt-6 md:mt-0 order-2 md:order-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-full bg-gradient-to-r from-[#E94B6C] to-[#9D4EDD] flex items-center justify-center text-white font-bold">
                4
              </div>
              <h3 className="text-white text-lg font-semibold">{t('mint.数字商城与消费生态')}</h3>
            </div>
            <p className="text-gray-300 leading-relaxed text-xs">
                {t('mint.包含链上数字商场，美股指数代币化配置、数码科技，潮玩周边涵盖限定手办、潮牌服饰、社区文创，作为生态身份象征。')}
              {/* 包含链上数字商场，美股指数代币化配置、数码科技，潮玩周边涵盖限定手办、潮牌服饰、社区文创，作为生态身份象征。 */}
            </p>
          </div>
          <div className="w-full md:w-1/2 order-1 md:order-2">
            <img  alt='rr' className=' ' src={require('../../assets/rasun/s4.jpg')} style={{"width":"100%"}}></img>
          </div>
        </div>

        {/* 第5个生态 */}
        <div className="mb-8 md:flex items-center gap-8">
          <div className="w-full md:w-1/2 mt-6 md:mt-0 order-2 md:order-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-full bg-gradient-to-r from-[#E94B6C] to-[#9D4EDD] flex items-center justify-center text-white font-bold">
                5
              </div>
              <h3 className="text-white text-lg font-semibold">{t('mint.前沿趋势布局')}</h3>
            </div>
            <p className="text-gray-300 leading-relaxed text-xs">
                {t('mint.引入AI Agent实现智能投研、自动做市、跨链套利和链上风控；结合RWA打造链上真实收益协议，让生态收益来源于真实商业利润；结合雷达宝支付网络，布局线下POS机、物联网设备，实现虚拟与现实的深度绑定。')}
              {/* 引入AI Agent实现智能投研、自动做市、跨链套利和链上风控；结合RWA打造链上真实收益协议，让生态收益来源于真实商业利润；结合雷达宝支付网络，布局线下POS机、物联网设备，实现虚拟与现实的深度绑定。 */}
            </p>
          </div>
          <div className="w-full md:w-1/2 order-1 md:order-2">
            <img  alt='rr' className=' ' src={require('../../assets/rasun/s5.jpg')} style={{"width":"100%"}}></img>
          </div>
        </div>
      </div>
    </div>
            {/*  */}

                    <Foot/>
        </main>
        
      </div>

      
        </>
        
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{

        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },

        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Box);
